import { MatPaginatorIntl } from '@angular/material/paginator';

export function getFrenchPaginatorIntl(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = $localize`Éléments par page :`;
  paginatorIntl.nextPageLabel = $localize`Suivant`;
  paginatorIntl.previousPageLabel = $localize`Précédent`;
  paginatorIntl.firstPageLabel = $localize`Première page`;
  paginatorIntl.lastPageLabel = $localize`Dernière page`;

  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return $localize`0 sur ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return $localize`${startIndex + 1} - ${endIndex} sur ${length}`;
  };

  return paginatorIntl;
}
